/**
 * Move a highlighted index over a list of length `length` in `direction`
 * (+1 down, -1 up), wrapping around the ends so navigation never dead-ends.
 *
 * Wrapping is friendlier than clamping for a small popup: pressing Up at the
 * top jumps to the bottom and vice-versa. An empty list (length 0) has no valid
 * index, so we return -1; any other length keeps the result in [0, length).
 */
export function nextHighlightIndex(current: number, length: number, direction: 1 | -1): number {
  if (length <= 0) {
    return -1
  }
  // Normalise `current` into range first so callers passing -1 / out-of-range
  // values still get a sane wrap, then add the step modulo length.
  const normalised = ((current % length) + length) % length
  return (normalised + direction + length) % length
}
